import React from "react"
import styled from 'styled-components'
import { Button } from 'reactstrap'
import get from 'lodash/get'
import { FONTS } from '../../../../constants'

export default class Searchbar extends React.Component {
  render() {
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const rSelected = get(this.props, 'rSelected')
    const isPresale = presale_snapshot && rSelected === 1
    const canEdit = get(projectByID, '$can_edit')
    const fallbackNanOrInfinity = (number) => {
      return number === 'NaN' || number === Infinity ? '0.00' : number
    }
    const total_licenses_cost = isPresale ? get(presale_snapshot, '$total_licenses_cost', '-') : get(projectByID, '$total_licenses_cost', '-')
    const total_licenses_price = isPresale ? get(presale_snapshot, '$total_licenses_price', '-') : get(projectByID, '$total_licenses_price', '-')
    const total_licenses_margin = isPresale ? fallbackNanOrInfinity(get(presale_snapshot, '$total_licenses_margin', '-')) : fallbackNanOrInfinity(get(projectByID, '$total_licenses_margin', '-'))

    const editLicense = get(this.props, 'editLicense')
    const clickEdit = get(this.props, 'clickEdit')
    const confirmEditLicense = get(this.props, 'confirmEditLicense')
    const cancelEdit = get(this.props, 'cancelEdit')
    const clickAddLicense = get(this.props, 'clickAddLicense')
    return (
      <SearchDivStyle >
        <Header>
          <TextHeader>Total Cost (฿)</TextHeader>
          <TextNumber>{ total_licenses_cost }</TextNumber>
          <TextHeader>Total Price (฿)</TextHeader>
          <TextNumber>{ total_licenses_price }</TextNumber>
          <TextHeader>Margin (%)</TextHeader>
          <TextNumber>{ total_licenses_margin } %</TextNumber>
        </Header>
        <SearchDiv>
          {/* <SearchField
            onChange={this.props.handleSearch}
            onKeyDown={ this.props.handleSearch }
            placeholder={ 'Search By Licensing Name, Code' }
          /> */}
          { !isPresale &&
            <ButtonGroup>
              { !editLicense && canEdit &&
                <CustomButton color='success' onClick={ () => clickEdit() }>Edit</CustomButton>
              }
              { editLicense &&
                <CustomButton color='success' onClick={ () => confirmEditLicense() }>Save</CustomButton>
              }
              { editLicense &&
                <CustomButton onClick={ () => cancelEdit() }>Cancel</CustomButton>
              }
              { editLicense &&
                <CustomButton color='danger' onClick={ () => clickAddLicense() }>Add Licensing/MA</CustomButton>
              }
            </ButtonGroup>
          }
        </SearchDiv>
      </SearchDivStyle>

    )
  }
}
const SearchDivStyle = styled.div`
  background-color: #ffffff ;
  margin-top: 10px;
`
const ButtonGroup = styled.div`
  text-align: right;
  margin: auto;
  margin-right: 0px !important;
  width: 50%;
`
const Header = styled.div`
  height: 60px;
  background: #404040;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`
// const SearchField = styled.input`
//   background: url(${SearchIcon}) no-repeat scroll 10px 10px;
//   background-size: 20px 20px;
//   padding-left:40px;
//   font-family: 'Gotham' !important;
//   font-size: 15px;
//   width: 20%;
//   height: 40px;
//   border: 1px solid #ccc;
//   border-radius: 4px;
//   margin: auto;
//   margin-left: 2% !important;
//   box-sizing: border-box;
//   -o-text-overflow: ellipsis;
//   -ms-text-overflow: ellipsis;
//   text-overflow: ellipsis;
//   ::placeholder {
//     color: #CCCCCC;
//   }
// `
const TextHeader = styled.p`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin:auto;
  margin-right: 20px !important;
`
const TextNumber = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin:auto;
  margin-left: 0% !important;
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin-left: 5px;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`
const SearchDiv = styled.div`
  height: 60px;
  padding: auto;
  display: flex;
  flex-direction: row;
`



// WEBPACK FOOTER //
// ./src/components/project-information/searchbar/searchbar-licensing/index.js